export enum BlockerResolveType {
  'UPLOAD_ATTACHMENT' = 'UPLOAD_ATTACHMENT',
  'ACCEPT_DECLINE' = 'ACCEPT_DECLINE',
  'FILL_FORM' = 'FILL_FORM',
}
